import React from "react";

interface Props {
  onClose: () => void;
  className?: string;
  style?: object;
}
function CloseButtonX({ onClose, className, style }: Props) {
  return (
    <button
      style={style}
      onClick={onClose}
      type="button"
      className={className + " close"}
      data-dismiss="alert"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  );
}

export default CloseButtonX;
